import { render, staticRenderFns } from "./ReportCard.vue?vue&type=template&id=d3370d22"
import script from "./ReportCard.vue?vue&type=script&lang=js"
export * from "./ReportCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/websites/streamlined-business-solutions/sbs-client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d3370d22')) {
      api.createRecord('d3370d22', component.options)
    } else {
      api.reload('d3370d22', component.options)
    }
    module.hot.accept("./ReportCard.vue?vue&type=template&id=d3370d22", function () {
      api.rerender('d3370d22', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/dashboard/ReportCard.vue"
export default component.exports